module.exports = __webpack_public_path__ + "static/media/wb.03b43260.svg";